module.exports = __webpack_public_path__ + "img/ba8a922.jpg";